/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Action
 */
export interface BattleStartAction { 
    /**
     * Civilization name 1
     */
    civilizationName1: string;
    /**
     * Units count 1
     */
    unitsCount1: number;
    /**
     * Civilization name 2
     */
    civilizationName2: string;
    /**
     * Units count 2
     */
    unitsCount2: number;
}